import cls from 'classnames';
import { useWindowSize } from 'usehooks-ts';

import theme from '../../../styles/theme';
import { TOOLS_BY_CATEGORY, IToolData } from '../../../data/tools';
import { colorsByCategory } from '../../../data/colorsByCategory';
import { SingleToolCard } from '../SingleToolCard';
import LoadMore from '../LoadMore';

import SameCategoryCard from './SameCategoryCard';
import { ISingleToolSimilarProps } from './types';
import useStyles from './styles';

const DESKTOP_LOAD_STEP_COUNT = 10;
const MOBILE_LOAD_STEP_COUNT = 5;

export default function SingleToolSimilar({
  analytics,
  className,
  similar,
  iconSize,
  category,
  current,
  otherTools,
  similarHeading = 'Suggestions for you',
}: ISingleToolSimilarProps) {
  const classes = useStyles();
  const categoryHeading = `Other ${category} tools`;
  const fromSameCategory =
    otherTools ?? TOOLS_BY_CATEGORY[category].filter((tool: IToolData) => tool.id !== current.id);
  const { width } = useWindowSize();
  const loadCount =
    width >= theme.breakpoints.tablet ? DESKTOP_LOAD_STEP_COUNT : MOBILE_LOAD_STEP_COUNT;

  const onClick = (id: string, component: string) => {
    analytics.toolSelect({
      page_name: current.id,
      action_type: id,
      component,
      category,
    });
  };

  return (
    <section className={cls(classes.root, className, 'landing-banner')}>
      <div className={classes.rootContainer}>
        <h4 className={classes.smallHeading}>{similarHeading}</h4>
        <div className={classes.list}>
          {similar.map(({ name, description, href, icon, id, isNew }) => (
            <SingleToolCard
              iconSize={iconSize}
              key={id}
              onClick={() => onClick(id, 'suggested_for_you')}
              href={href}
              icon={icon}
              name={name}
              description={description}
              hasNewLabel={isNew}
            />
          ))}
        </div>
        <h4 className={classes.smallHeading}>{categoryHeading}</h4>
        <ul className={classes.sameCategoryContainer}>
          <LoadMore loaded={loadCount} text="Load more tools">
            {fromSameCategory.map(({ name, href, icon, id }) => (
              <SameCategoryCard
                key={name}
                text={name}
                href={href}
                iconProps={{
                  size: 'small',
                  icon: {
                    ...icon,
                    ...colorsByCategory[category],
                  },
                }}
                onClick={() => onClick(id, 'same-category')}
              />
            ))}
          </LoadMore>
        </ul>
      </div>
    </section>
  );
}
